import Navbar from "../../components/navbar/Navbar";
import Features from "./Features";
import Home from "./Home";
import AboutUs from "./AboutUs";
import Footer from "../../components/footer/Footer";

const Landing = () => {
  return (
    <>
      <Home />

      <Features />

      <AboutUs />
      <Footer />
    </>
  );
};

export default Landing;
